// @flow

import { Screen } from '@zapier/theme';
import { useMediaProps } from '@zapier/responsive-utils';

import type { Size } from '../types';

const useSize = (): Size =>
  useMediaProps({
    all: {
      size: 'small',
    },
    [Screen.queries.tablet]: { size: 'medium' },
    [Screen.queries.desktop]: { size: 'large' },
  }).size;

export default useSize;
